import React, { useState, useEffect, useRef } from 'react'
import ListItemText from '@material-ui/core/ListItemText'
import Tooltip from '@material-ui/core/Tooltip'
import Fade from '@material-ui/core/Fade'
import { withStyles } from '@material-ui/core/styles'

const TooltipText = ({ selectedClasses, children }) => {
    const textElementRef = useRef()

    const compareSize = () => {
        let compare
        if (selectedClasses === 'MuiMenuItem-descriptionTextTwoLines') {
            compare =
                textElementRef.current.children[0]?.scrollHeight >
                textElementRef.current.children[0]?.offsetHeight
        } else {
            compare =
                textElementRef.current.children[0]?.scrollWidth >
                textElementRef.current.children[0]?.offsetWidth
        }

        setHover(compare)
    }

    useEffect(() => {
        compareSize()
        window.addEventListener('resize', compareSize)
        return window.removeEventListener('resize', compareSize)
    }, [children])

    const [hoverStatus, setHover] = useState(false)

    const StyledTooltip = withStyles(theme => ({
        tooltip: {
            fontWeight: '600',
            fontSize: '12px',
            lineHeight: '16px',
            color: theme.palette.grey[100],
            backgroundColor: theme.palette.grey[700],
            maxWidth: '220px',
            maxHeiht: '52px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            textAlign: 'center',
            padding: '10px 12px',
            borderRadius: '5px'
        },
        arrow: {
            color: theme.palette.grey[700]
        }
    }))(Tooltip)

    return (
        <StyledTooltip
            disableHoverListener={!hoverStatus}
            title={children}
            TransitionComponent={Fade}
            TransitionProps={{ timeout: 600 }}
            arrow
        >
            <ListItemText
                ref={textElementRef}
                className={selectedClasses}
                primary={children}
            />
        </StyledTooltip>
    )
}

export default TooltipText
